<template>
  <simple-page>
    <template v-slot:pageItem>
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
    </template>

    <template v-slot:pageTitle>
      <h1 class="text-upper-case">Pending Group Submissions</h1>
      <button class="clear-search" @click="clearFilter">Clear Search</button>
    </template>

    <template v-slot:filter>
      <pending-submission-filter :filters="filterQuery" @onSearch="handleFilterChange" />
    </template>

    <template v-slot:topPagination>
      <div
        class="top-pagination d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-3 mb-2">
        <pagination class="m-0" :rows.sync="groupRows" :filters="filterQuery" />

        <button v-if="selectedItems.length > 1" class="btn-bulk mt-0 mb-2 univ-btn" v-b-modal.bulkApproval>
          Bulk Submit Enrollment
        </button>
        <button v-if="selectedItems.length > 1" class="btn-bulk-withdraw mt-0 mb-2 univ-btn" v-b-modal.bulkWithdraw>
          Bulk Withdraw
        </button>
      </div>
    </template>

    <template v-slot:table>


      <div class="table-responsive">
        <table class="table group-pending-table">
          <thead>
            <tr>
              <th>Group Info</th>
              <!-- <th>Dates</th> -->
              <th>Rep</th>
              <th>Totals</th>
              <th>Pending Members</th>
              <th>Actions</th> 
            </tr>
          </thead>

          <tbody>
            <tr v-if="loading">
              <td colspan="6" class="text-center">Loading...</td>
            </tr>

            <tr v-if="!loading && groupRows.records.length === 0">
              <td colspan="6" class="text-center text-danger">No items found</td>
            </tr>
            <!-- MAIN ROW -->
            <template v-for="(item, index) in groupRows.records">
              <template v-if="item">
                <!-- Main Row -->
                <tr class="member-row" :key="'member-' + (item.group_id || index)">
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <div class="d-flex align-items-center gap-2">
                        <strong class="group-name">{{ item.group_name }}</strong>
                        <span v-if="item.pending_submission.isNew" class="badge eventBadge new-group m-0">NEW GROUP</span>
                      </div>
                    </div>
                        <div class="inline-warning mt-2" v-if="item.pending_submission.isNew && item.pending_submission.count < 2">
                            <i class="fas fa-info-circle"></i>
                            This is a <strong class="ms-1">new group</strong>. At least <strong class="mx-1">2
                              members</strong> are required to submit
                            enrollment as a group, or you can proceed as an <strong class="ms-1">individual enrollment. </strong>
                        </div>
                    <div class="group-id-small text-muted">{{ item.group_code }}</div>
                    <div class="group-id-small text-muted">{{ item.group_email }}</div>
                      <span :class="item.group_status.toLowerCase() == 'active' ? 'id-status-active': 'id-status-inactive'">{{ item.group_status }}</span>
                  </td>

                  <!-- <td>
                    Selected: {{ selectedItems }}<br/>
                      <strong>Enrollment:</strong> {{ getLatestEnroll(item)?.edate_convert || 'No date available' }}<br />
                      <strong>Effective:</strong> {{ getLatestEnroll(item)?.formatted_effective_date || 'No effective date' }}<br/>
                  </td> -->

                  <td>
                    <strong>{{ item.group_ga_agent_full_name }}</strong><br />
                    <span class="text-muted">{{ item.group_ga_agent_code }}</span>
                  </td>
                  <td>
                    <ul class="stats-grid">
                      <li><strong>A:</strong> {{ item.active_total }}</li>
                      <li><strong>W:</strong> {{ item.withdraw_total }}</li>
                      <li><strong>T:</strong> {{ item.termed_total }}</li>
                      <li>
                        <strong>Total:</strong>
                        {{
                          getStatTotal(
                            item.active_total,
                            item.withdraw_total,
                            item.termed_total
                          )
                        }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <div class="d-flex flex-column align-items-center gap-2 pending-member-cell">
                      <span class="badge eventBadge d-flex align-items-center gap-1 w-100 ms-0">
                        <span>
                          <i class="fas fa-users me-1"></i>
                          Pending Members -
                        </span>
                        <span>
                          {{ item.pending_submission?.count || 0 }}
                        </span>
                      </span>

                      <div class="member-toggle-btn w-100" @click="loadGroupMembers(item.group_id)">
                        <i class="fas" :class="expandedRow === item.group_id ? 'fa-eye-slash' : 'fa-eye'"></i>
                        <span class="text-nowrap">
                          {{ expandedRow === item.group_id ? "Hide Members" : "View Members" }}
                        </span>
                      </div>
                    </div>
                  </td>

                  <td>
                       <div class="action-icons">
                         <custom-button iconClass="fas fa-arrow-up-right-from-square" class="submit-action-btn"
                         @click.native="selectItem(item)"
                         v-b-tooltip.hover
                         
                         :title="item.pending_submission.isNew && item.pending_submission.count < 2 ? 'Individual Enrollment' : 'Submit Enrollment'"
                    />
                    <custom-button iconClass="fas fa-times-circle" class="withdraw-action-btn"
                         @click.native="selectItemForWithdraw(item)"
                         v-b-tooltip.hover
                         
                         title="Withdraw Enrollment"
                    />
                  </div>
                </td>
                </tr>

                <!-- EXPANDED MEMBER ROW -->
                <tr v-if="expandedRow === item.group_id" class="expanded-member-row"
                  :key="'expanded-' + (item.group_id || index)">
                  <td colspan="6" class="p-0">
                    <div class="expanded-content p-3 bg-light">
                      <div v-if="loadingMembers" class="text-center p-3">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2">Loading members...</p>
                      </div>
                      <template v-else>
                        <div class="expanded-wrapper">
                          <div class="expanded-header d-flex align-items-center gap-3">
                            <strong>Pending Members</strong>

                            <div class="form-check m-0">
                              <input 
                                class="form-check-input" 
                                type="checkbox"
                                :checked="allMembersSelected(item)" 
                                @change="toggleSelectAllMembers(item)" 
                                :id="'selectAllCheckbox-' + item.group_id" 
                               
                              />
                              <label class="form-check-label" :for="'selectAllCheckbox-' + item.group_id">
                                {{ allMembersSelected(item) ? 'Deselect All' : 'Select All' }}
                              </label>
                            </div>

                            <div class="member-toggle-btn" @click="openApproveModal(item)">
                              <i class="fas fa-file-export"></i>
                              <span v-if="item.pending_submission.count < 2">Individual Enrollment</span>
                              <span v-else>Submit Enrollment</span>
                            </div>

                            <div class="member-toggle-btn withdraw-btn" @click="openWithdrawModal(item)">
                              <i class="fas fa-times-circle"></i>
                              <span>Withdraw Enrollment</span>
                            </div>
                          </div>

                          <!-- Inline Warning for New Group Condition -->
                          <div class="inline-warning mt-2" v-if="item.pending_submission.count < 2">
                            <i class="fas fa-info-circle"></i>
                            This is a <strong class="ms-1">new group</strong>. At least <strong class="mx-1">2
                              members</strong> are required to submit
                            enrollment as a group, or you can proceed as an <strong class="ms-1">individual enrollment. </strong>
                          </div>

                          <div class="members-list">
                            <div v-for="member in memberRows.records" :key="member.id"
                              class="member-item d-flex align-items-center p-3 border-bottom">
                                <!--:disabled="item.pending_submission.count < 2"-->
                              <input type="checkbox" 
                                class="form-check-input me-3" 
                                :checked="isMemberSelected(member)" 
                                @change="toggleMemberSelection(member, $event)"
                              />
                              <div class="member-info flex-grow-1">
                                <div class="member-info">
                                  <strong>{{ member.first_name }} {{ member.last_name }}</strong>
                                  <div class="text-muted">
                                  <b>Policy ID:</b> {{ member.policy_id }}
                                  <br/>
                                    {{ member.user_email }} • {{ member.phone }}</div>
                                </div>
                              </div>
                              <div class="member-plan ms-auto">
                                {{ member.plan_details?.[0]?.plan_name_system || 'N/A' }} — {{
                                  member.plan_details?.[0]?.plan_price || '0.00' }}
                                  <div class="text-muted">
                                  <b>Effective Date:</b> {{ member.effective_date }}
                                  <br/>
                                  <b>Enrollment Date:</b> {{ member.enrollment_date }}
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
        <bulk-approval :isIndividualEnrollment="isIndividualEnrollment" @close="selectNone" @submit="onApproveSubmit" />
        <approval @close="selectNone" @submit="onApproveSubmit" />
        <bulk-withdraw :isIndividualEnrollment="isIndividualEnrollment" @close="selectNone" @submit="onWithdrawSubmit" />
        <withdraw @close="selectNone" @submit="onWithdrawSubmit" />
      </div>
    </template>
  </simple-page>
</template>


<script>
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue";
import SimplePage from "../../components/ui/SimplePage.vue";
import PendingSubmissionFilter from "./partials/PendingSubmissionFilter.vue";
import Api from "@/resource/Api";
import BulkApproval from "./BulkApproval.vue";
import Approval from "./Approve.vue";
import BulkWithdraw from "./BulkWithdraw.vue";
import Withdraw from "./Withdraw.vue";
import Helper from "@/resource/Helper";
import Pagination from "@/components/ui/Pagination.vue";
import Breadcrumb from "../../components/ui/Breadcrumb.vue";
import axios from "axios";

export default {
  name: "PendingSubmission",
  components: {
    SimplePage,
    PendingItemsInternal,
    Pagination,
    BulkApproval,
    PendingSubmissionFilter,
    Approval,
    BulkWithdraw,
    Withdraw,
    Breadcrumb,
  },
  data() {
    return {
      memberRows: { records: [] },
      groupRows: { records: [] },
      expandedRow: null,
      loadingMembers: false,
      filterQuery: {
        group_name: "",
        group_code: "",
        group_email:"",
        agent_code: "",
        status: "",
        enrollment_date: "",
        state: "",
        enrollment_from: "",
        enrollment_to: "",
        rep_id: "",
        isPendingSubmission: 1,
        page_size: 100,
      },
      breadcrumbItems: [{ title: "Pending Group Submissions", active: true }],
      selectedItem: null,
      currentPage: 1,
      totalRows: 0,
      dialogDeleteComm: false,
      loading: false,
      selectedItems: [],
      allSelected: false,
      isIndividualEnrollment: false
    };
  },
  computed: {
    repId() {
      return this.$store.getters.repId;
    },
  },
  mounted() {
    this.$store.dispatch("getPendingStats");
    this.loadPendingSubmissionGroup()
  },
  methods: {
    getLatestEnroll(item) {
      if (!item?.pending_submission?.list?.length) return null;
      
      const latest = item.pending_submission.list.reduce((latest, current) => {
        if (!latest) return current;
        const currentDate = new Date(current.edate_convert);
        const latestDate = new Date(latest.edate_convert);
        return currentDate > latestDate ? current : latest;
      }, null);

      if (latest?.effective_date) {
        const date = new Date(latest.effective_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        latest.formatted_effective_date = 
          `${day}/${month}/${year}`;
      }
      
      return latest;
    },
    clearFilter() {
      Object.keys(this.filterQuery).forEach((key) => (this.filterQuery[key] = ""));
      this.filterQuery.page_size = 100;
      this.loadPendingSubmissionGroup();
    },
    handleFilterChange(newFilters) {
      this.filterQuery = { ...this.filterQuery, ...newFilters };
      this.currentPage = 1;
      this.loadPendingSubmissionGroup();
    },
    encodedId(id) {
      return btoa(id);
    },

    async loadGroupMembers(groupId) {

      if (this.expandedRow === groupId) {
        this.expandedRow = null;
        return;
      }
      const group = this.groupRows.records.find(g => g.group_id === groupId);
      if (!group) return;

      this.expandedRow = groupId;
      this.selectedItems = [];


      this.loadingMembers = true;
      try {
        const baseUrl = 'v2/get-members';
        const queryParams = {
          is_group_submitted: '0',
          group_id: groupId,
          page_size: 1000,
        };

        const filterUrl = Helper.objToUrlParams(queryParams);
        const url = `${baseUrl}?${filterUrl}`;
        const response = await Api.get(url);

        this.$set(this, 'memberRows', response.data);
        this.loadingMembers = false;
      } catch (error) {
        console.error('Error loading group members:', error);
        this.memberRows = { records: [] };
        this.loadingMembers = false;
      } finally {
        this.loadingMembers = false;
        // console.log('Member loading finished for group:', groupId, 'expandedRow:', this.expandedRow, 'loadingMembers:', this.loadingMembers);
      }
    },

    async loadPendingSubmissionGroup() {
      this.loading = true;
      let loader = this.$loading.show();
      this.groupRows = { records: [] };
      this.expandedRow = null;
      try {
        const baseUrl = 'v2/get-all-employer-and-group';
        const queryParams = {
          ...this.filterQuery,
        };
        Object.keys(queryParams).forEach((key) => {
          if (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) {
            delete queryParams[key];
          }
        });

        if (!queryParams.page_size) {
          queryParams.page_size = 100;
        }
        const filterUrl = Helper.objToUrlParams(queryParams);
        const url = `${baseUrl}?${filterUrl}`;
        const response = await Api.get(url);
        const data = response.data || { records: [] };
        data.path = 'v2/get-all-employer-and-group';
        this.groupRows = data;
      } catch (error) {
        console.error("Error loading pending group submissions:", error);
        this.groupRows = { records: [] };
      } finally {
        this.loading = false;
        loader.hide();
      }
    },
    selectItem(item) {
      this.selectedItems = item?.pending_submission?.list.map(item => item.policy_id) || [];
      this.setIndividualEnrollment(item)
      this.allSelected = this.selectedItems.length === item.pending_submission.count;
      // console.table({
      //   selectedItems: this.selectedItems,
      //   allSelected: this.allSelected
      // });

      if(this.allSelected){
        this.$bvModal.show('bulkApproval');
      }
      else{
        this.$bvModal.show('approval');
      }
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedItems = this.groupRows.records.map(item => item.policy_id);
      } else {
        this.selectedItems = [];
      }
    },
    updateSelectAll() {
      this.allSelected = this.selectedItems.length === this.rows.records.length;
      this.selectedItems = [...new Set(this.selectedItems)];
    },
    selectNone() {
      this.selectedItems = [];
      this.allSelected = false;
      // console.table({
      //   selectedItems: this.selectedItems,
      //   allSelected: this.allSelected
      // });
    },
    async submit() {
      let loader = this.$loading.show();
      let headers = {
        'source': 'rep',
        'X-Internal-Token': Helper.nueraProtectedApiToken(),
        'Id': this.repId,
      };
      let url = process.env.VUE_APP_NUERA_BENEFITS + '/v2/approve-group-submission';

      let payload = {
        policy_ids: this.selectedItems,
        individual_enrollment: this.isIndividualEnrollment,
      };

      try {
        await axios.post(url, payload, { headers });
        this.$bvModal.hide('approval');
        this.$bvModal.hide('bulkApproval');
        this.selectNone();
        this.loadPendingSubmissionGroup();
        this.$store.dispatch("getPendingStats");
        this.$notify('Group submission approved successfully','success');
      } catch (error) {
        console.log(error);
        this.$notify('Something went wrong. Please try again.', 'error');
      } finally {
        loader.hide();
      }

    },
    onApproveSubmit() {
      this.submit();
    },
    openApproveModal(item) {
      if (this.selectedItems.length === 0) {
        return;
      }
      let policies =  item.pending_submission?.list.map(item => item.policy_id) || [];
      this.allSelected = this.selectedItems.length == policies.length && this.selectedItems.every((v,i) => v === policies[i]);
      this.isIndividualEnrollment = item.pending_submission.isNew && item.pending_submission.count === 1;
      if (this.allSelected) {
        this.$bvModal.show('bulkApproval'); 
      }
      else {
        this.$bvModal.show('approval'); 
      }

    },
    // Toggle all members for a single group
    toggleSelectAllMembers(item) {
      if (item.pending_submission.isNew && item.pending_submission.count < 2) {
       // this.$notify('A new group must have at least 2 members to submit.', 'error');
       // return;
      }
      const policies = item.pending_submission?.list.map(item => item.policy_id) || [];
      const allSelected = this.allMembersSelected(item);
      
      this.setIndividualEnrollment(item)
      if (allSelected) {
        // Deselect all policies for this group
        this.selectedItems = this.selectedItems.filter(id => !policies.includes(id));
      } else {
        // Select all policies for this group
        const newSelections = policies.filter(id => !this.selectedItems.includes(id));
        this.selectedItems = [...this.selectedItems, ...newSelections];
      }
      
    },
    
    allMembersSelected(item) {
      const policies = item.pending_submission?.list.map(item => item.policy_id) || [];
      if (policies.length === 0) return false;
      return policies.every(policyId => this.selectedItems.includes(policyId));
    },
    
    isMemberSelected(member) {
      return this.selectedItems.includes(member.policy_id);
    },
    
    toggleMemberSelection(member, event) {
      const isSelected = event.target.checked;
      
      if (isSelected) {
        if (!this.selectedItems.includes(member.policy_id)) {
          this.selectedItems.push(member.policy_id);
        }
      } else {
        this.selectedItems = this.selectedItems.filter(id => id !== member.policy_id);
      }
    },
    getStatTotal(activeTotal, withdrawTotal, termedTotal) {
      let total = 0;
      total =
        parseInt(activeTotal) + parseInt(withdrawTotal) + parseInt(termedTotal);
      return total;
    },
    setIndividualEnrollment(item){
      // console.log(item)
      this.isIndividualEnrollment = item.pending_submission.isNew && item.pending_submission.count === 1;
      // console.log('individual enrollment', item.pending_submission.isNew && item.pending_submission.count === 1);
    },
    selectItemForWithdraw(item) {
      this.selectedItems = item?.pending_submission?.list.map(item => item.policy_id) || [];
      this.setIndividualEnrollment(item)
      this.allSelected = this.selectedItems.length === item.pending_submission.count;
      // console.table({
      //   selectedItems: this.selectedItems,
      //   allSelected: this.allSelected
      // });

      if(this.allSelected){
        this.$bvModal.show('bulkWithdraw');
      }
      else{
        this.$bvModal.show('withdraw');
      }
    },
    openWithdrawModal(item) {
      if (this.selectedItems.length === 0) {
        return;
      }
      let policies =  item.pending_submission?.list.map(item => item.policy_id) || [];
      this.allSelected = this.selectedItems.length == policies.length && this.selectedItems.every((v,i) => v === policies[i]);
      this.isIndividualEnrollment = item.pending_submission.isNew && item.pending_submission.count === 1;
      if (this.allSelected) {
        this.$bvModal.show('bulkWithdraw'); 
      }
      else {
        this.$bvModal.show('withdraw'); 
      }
    },
    async withdraw() {
      let loader = this.$loading.show();
      let headers = {
        'source': 'rep',
        'X-Internal-Token': Helper.nueraProtectedApiToken(),
        'Id': this.repId,
      };
      let url = process.env.VUE_APP_NUERA_BENEFITS + '/v2/policy/withdraw-group-submission';

      let payload = {
        policy_ids: this.selectedItems,
        individual_enrollment: this.isIndividualEnrollment,
        rep_id: this.repId,
      };

      try {
        await axios.post(url, payload, { headers });
        this.$bvModal.hide('withdraw');
        this.$bvModal.hide('bulkWithdraw');
        this.selectNone();
        this.loadPendingSubmissionGroup();
        this.$store.dispatch("getPendingStats");
        this.$notify('Group submission withdrawn successfully','success');
      } catch (error) {
        console.log(error);
        this.$notify('Something went wrong. Please try again.', 'error');
      } finally {
        loader.hide();
      }
    },
    onWithdrawSubmit() {
      this.withdraw();
    }
  },
};
</script>
<style src="@/assets/css/viewclients.css"></style>
<style scoped>
.btn-bulk {
  background-color: #8e9a91;
  border: #8e9a91;
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  padding: 10px 12px;
  width: fit-content;
}

.btn-bulk:hover {
  background-color: transparent linear-gradient(180deg, #0cf, #1597b8 49%, #0567bc) !important;
  border: none !important;
}

.btn-bulk-withdraw {
  background-color: #dc3545;
  border: #dc3545;
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  padding: 10px 12px;
  width: fit-content;
}

.btn-bulk-withdraw:hover {
  background-color: #c82333 !important;
  border: none !important;
}

.submit-action-btn {
  background: transparent linear-gradient(180deg, #0cf, #1597b8 49%, #0567bc);
}

.withdraw-action-btn {
  background-color: #dc3545;
}

.withdraw-action-btn:hover {
  background-color: #c82333 !important;
}

.action-btns.actionBtnwrapper a {
  font-size: 12px;
  width: 28px;
  height: 28px;
  color: #fff;
  display: inline-flex;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin: 10px 8px;
}

.route-link {
  color: #0cf;
}

.planstable tr,
.planstable tr td {
  border: 1px solid transparent;
}

.page-card .planstable tr:nth-child(even) {
  background: transparent !important;
}

.group-pending-table .action-icons {
  width: auto;
}

.expanded-member-row {
  background: #f9fafb;
}

.expanded-wrapper {
  padding: 12px 0px;
}

.expanded-header {
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
}

.expanded-member {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid #e6e6e6;
}

.group-name {
  font-size: 15px;
  color: #333;
  font-weight: 600;
}


.submit-action-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.new-group {
  background: #f1fafc;
  color: #1597b8;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.2px;
  border: none;
}

.inline-warning {
  align-items: center;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 6px;
}

.inline-warning i {
  margin-right: 8px;
  color: #d9534f;
}

.inline-warning strong {
  color: #d9534f;
}

.pending-member-cell .fa-users {
  font-size: 10px;
  padding: 5px 4px;
  border-radius: 100%;

}

.pending-member-cell .badge {
  background: transparent;
  color: #1597b8;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  border: none;
}

.member-toggle-btn {
  font-size: 10.5px;
  background: #e6f7fb;
  color: #0cf;
  padding: 6px 0.5rem;
  border-radius: 4px;
  border: 1px solid #c7e9f1;
  width: fit-content;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.member-toggle-btn.withdraw-btn {
  background: #f8d7da;
  color: #dc3545;
  border: 1px solid #f5c6cb;
}

.member-toggle-btn.withdraw-btn:hover {
  background: #f1b0b7;
  transform: translateY(-1px);
}

.member-toggle-btn i {
  font-size: 11px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 8px 16px; /* row gap | column gap */
  list-style: none;
  padding: 0;
  margin: 0;
}


</style>
